import React, { Component } from 'react';

import { withApollo } from 'react-apollo';
import SelectorModelo from '../tramites/formularios/SelectorModelo';
import CKEditor from '../editor/Example';
import Generador from '../generador/Generador';
import { imprimir } from '../common/funciones/imprimir';
import obtenerNumeroTalonario from '../../graphql/mutations/editor/obtenerNumeroTalonario.graphql';
import { notification } from 'antd/lib';

class ProcesoImprimir extends Component {
  state = {
    nota: {
      idModeloNota: '',
      titulo: '',
      descripcion: '',
      htmlModelo: '',
    },
    step: 0,
  };

  notaSeleccionada = idNota => {
    this.setState({
      ...this.state,
      nota: {
        idModeloNota: idNota,
      },
    });
  };

  finProcesoGeneracion = textoGenerado => {
    this.setState(
      {
        ...this.state,
        nota: {
          ...this.state.nota,
          htmlModelo: textoGenerado,
        },
      },
      function() {
        // this.siguientePaso();
        let step = this.state.step;
        step = step + 1;
        this.setState({
          step: step,
        });
      }
    );
  };

  onGuardar = htmlFinal => {
    this.props.onGuardar(
      htmlFinal,
      this.state.nota.idModeloNota,
      this.state.numero
    );
  };

  onImprimir = htmlFinal => {
    // console.log("Lo que se mando a imprimir fue....");
    // console.log(htmlFinal);
    imprimir(htmlFinal);
    this.props.onImprimir(
      htmlFinal,
      this.state.nota.idModeloNota,
      this.state.numero
    );
  };

  onCancel = () => {
    //El cancelar reinicia todo el estado de la aplicacion para volver a empezar desde 0
    this.setState({
      nota: {
        idModeloNota: '',
        titulo: '',
        descripcion: '',
        htmlModelo: '',
      },
      step: 0,
    });

    if (this.props.onCancel) {
      this.props.onCancel();
    }
  };

  siguientePaso = () => {
    //Metodo que se encarga de aumentar en 1 el paso y es llamado por todos los metodos auxiliares
    let paso = this.state.step;
    paso++;

    this.props.client
      .mutate({
        mutation: obtenerNumeroTalonario,
        variables: {
          idModeloNota: this.state.nota.idModeloNota,
        },
      })
      .then(respuesta => {
        // console.log("Recibi de respuesta....");
        // console.log(respuesta);

        if (respuesta.data.obtenerNumeroTalonario == -1) {
          notification.warning({
            message: 'Talonario no configurado',
            description:
              'El modelo de nota no tiene configurado el talonario a usar',
          });
        }

        this.setState({
          ...this.state,
          numero: respuesta.data.obtenerNumeroTalonario
            ? respuesta.data.obtenerNumeroTalonario
            : 0,
          loading: false,
          step: paso,
        });
      })
      .catch(err => {
        console.log('ERROR a la hora de obtener el numero del  talonario');
        console.log(err);
      });
  };

  anteriorPaso = () => {
    let paso = this.state.step;
    if (paso > 0) {
      paso--;
      this.setState({
        ...this.state,
        step: paso,
      });
    }
  };

  render() {
    let { step } = this.state;

    let nuevosDatos = this.props.datos;
    if (this.state.numero) {
      nuevosDatos = {
        ...nuevosDatos,
        numero: this.state.numero,
      };
    }
    return (
      <div>
        {step === 0 && (
          <SelectorModelo
            handleChange={this.notaSeleccionada}
            onSubmit={this.siguientePaso}
          />
        )}
        {step === 1 && (
          <Generador
            id={this.state.nota.idModeloNota}
            // datos={this.state.persona}
            datos={nuevosDatos}
            mostrarEditor={this.finProcesoGeneracion}
          />
        )}
        {step === 2 && (
          <CKEditor
            modelo_nota={this.state.nota}
            onImprimir={this.onImprimir}
            onGuardar={this.onGuardar}
            onCancel={this.onCancel}
            accion="visualizar"
          />
        )}
      </div>
    );
  }
}

export default withApollo(ProcesoImprimir);
